import { Reducer } from "react"
import { handleActions } from "redux-actions"
import { 
    ACTION_GETADMININFO_SUCCESS,
    ACTION_ADDADMIN_SUCCESS,
    ACTION_DELETEADMIN_SUCCESS,
    ACTION_UPDATEINSTITUTION_SUCCESS,
    ACTION_UPDATESTORE_SUCCESS,
} from "../../actions/silizhu/account"

export interface silizhuAccountState {
    adminList: any
}

const defaultState: silizhuAccountState = {
    adminList: [],
}

function handleActionGetAdminInfoSuccess(state: silizhuAccountState, action): silizhuAccountState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        adminList: action.payload.data
    }
}

function handleActionNoDataSuccess(state: silizhuAccountState, action): silizhuAccountState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
}

export const silizhuAccountReducer: Reducer<silizhuAccountState, any> = handleActions(
    {
        [ACTION_GETADMININFO_SUCCESS]: handleActionGetAdminInfoSuccess,
        [ACTION_ADDADMIN_SUCCESS]: handleActionNoDataSuccess,
        [ACTION_DELETEADMIN_SUCCESS]: handleActionNoDataSuccess,
        [ACTION_UPDATEINSTITUTION_SUCCESS]: handleActionNoDataSuccess,
        [ACTION_UPDATESTORE_SUCCESS]: handleActionNoDataSuccess,
    },
    defaultState
)